
export const validItemIdParam = ':itemId(\\d+_[a-z0-9]{8})';
export const getValidItemId = itemId => (/^\d+_[a-z0-9]{8}$/.exec(itemId) || [null])[0];

const mediaFilterParam = ':mediaFilter(plaatjes|filmpjes)';
const listTypeParam = ':listType(latest|nieuw|datum|toppers|top|floppers)';
const relatedListTypeParam = ':listType(latest|toppers|related)';
const pageNumParam = ':pageNum(\\d+|dag|week|maand|\\d{2}-\\d{2}-\\d{4})';

export const LIST_PAGE_PATH =
  `/${mediaFilterParam}?/${listTypeParam}?/${pageNumParam}?/:offset(\\d+)?/`;
export const TAG_PAGE_PATH = '/:listType(tag|zoek)/:tagId?/:pageNum(\\d+)?';
export const ITEM_PAGE_PATH = `/item/${validItemIdParam}/${relatedListTypeParam}?`;
export const ITEM_EMBEDDED_PAGE_PATH = `/embed/${validItemIdParam}`;
